<div #productOverviewRef>
  <app-breadcrumb [categoryId]="(category$ | async)?.id" #breadcrumbRef></app-breadcrumb>
  <div class="product-overview">
    <app-online-filter-menu [categoriesTitle]="filterMenu.categoryTitle" [allProducts]="filterMenu.allProducts"></app-online-filter-menu>
    <app-text-button class="filter-button" (click)="openFilterMenu()">{{ openCategoriesMenu }}</app-text-button>
    @let loading = loading$ | async;
    <div class="product-overview-content">
      @if (enableSearch) {
        <div class="search-bar" [class.hidden]="(category$ | async) !== undefined">
          <input #searchInput type="search" [placeholder]="searchPlaceholder" [(ngModel)]="searchTerm" name="product-search" />
          @if (searchTerm) {
            <app-icon-button buttonType="button" [icon]="clearIcon" [border]="false" (click)="clearSearch(true)"></app-icon-button>
          }
        </div>
      }
      <div class="product-overview-header" #target>
        @let category = category$ | async;
        <div class="title">
          @if (!category && allProductsTitle) {
            <h1>{{ allProductsTitle }}</h1>
          }
          @if (category) {
            <h1>{{ category.title || category.name }}</h1>
          }
          @if (category || allProductsTitle) {
            <span>{{ pageTotal$ | async }} varer</span>
          }
        </div>
      </div>
      <div
        infiniteScroll
        [infiniteScrollDistance]="3"
        [infiniteScrollThrottle]="50"
        [infiniteScrollDisabled]="reset"
        class="product-overview-cards"
      >
        @for (product of products$ | async; track product.id) {
          <app-online-product-card [@searchItemAnimation] [product]="product"></app-online-product-card>
        }
      </div>
      @if (!loading && pageTotal$ | async; as pageTotal) {
        @let pageShowing = pageShowing$ | async;
        <span class="currently-showing">
          Viser {{ pageShowing > pageTotal ? pageTotal : pageShowing }} ud af {{ pageTotal }} produkter
        </span>
        @if (hasMore() && pageSize$ | async; as pageSize) {
          <app-text-button class="load-more" (click)="loadMore()">
            Vis næste {{ pageTotal - pageShowing < pageSize ? pageTotal - pageShowing : pageSize }} produkter
          </app-text-button>
        }
      }
      @if (loading) {
        <div class="loading">
          <img src="assets/preloader.gif" [alt]="loadingProductsAlt" />
        </div>
      }
    </div>
  </div>
</div>
@if ((category$ | async)?.description; as description) {
  <div [innerHTML]="description | sanitizeHtml" class="description rich-text"></div>
}

@if (strips | async; as strips) {
  @if (strips?.length) {
    <app-strip-container [strips]="strips"></app-strip-container>
  }
}

<app-icon-button
  class="scroll-to-top"
  [@showHide]="showScrollToTop ? 'show' : 'hide'"
  [icon]="arrowIcon"
  [smallIcon]="true"
  (click)="scroll(productOverviewRef)"
></app-icon-button>
